const pages = [
    {
        "id": "1",
        "name": "首页",
        "path": "/",
        "parent": null,
        "closable": false
    },
    {
        "id": "2-1",
        "name": "采购订单",
        "path": "/purchase/order",
        "parent": "2",
        "closable": true
    },
    {
        "id": "2-1-1",
        "name": "采购订单详情",
        "path": "/purchase/order/detail",
        "parent": "2-1",
        "closable": true
    },
    {
        "id": "2-1-2",
        "name": "新增采购订单",
        "path": "/purchase/order/add",
        "parent": "2-1",
        "closable": true
    },
    {
        "id": "2-2",
        "name": "发货单",
        "path": "/purchase/invoice",
        "parent": "2",
        "closable": true
    },
    {
        "id": "2-2-1",
        "name": "发货单详情",
        "path": "/purchase/invoice/detail",
        "parent": "2-2",
        "closable": true
    },
    {
        "id": "2-3",
        "name": "采购单",
        "path": "/purchase/po",
        "parent": "2",
        "closable": true
    },
    {
        "id": "2-3-1",
        "name": "采购单详情",
        "path": "/purchase/po/detail",
        "parent": "2-3",
        "closable": true
    },
    {
        "id": "2-3-2",
        "name": "新增采购单",
        "path": "/purchase/po/add",
        "parent": "2-3",
        "closable": true
    },
    {
        "id": "2-4",
        "name": "采购退货",
        "path": "/purchase/ro",
        "parent": "2",
        "closable": true
    },
    {
        "id": "2-4-1",
        "name": "采购退货单详情",
        "path": "/purchase/ro/detail",
        "parent": "2-4",
        "closable": true
    },
    {
        "id": "2-4-2",
        "name": "新增采购退货单",
        "path": "/purchase/ro/add",
        "parent": "2-4",
        "closable": true
    },
    {
        "id": "3-1",
        "name": "销售订单",
        "path": "/sale/order",
        "parent": "3",
        "closable": true
    },
    {
        "id": "3-1-1",
        "name": "销售订单详情",
        "path": "/sale/order/detail",
        "parent": "3-1",
        "closable": true
    },
    {
        "id": "3-1-2",
        "name": "新增销售订单",
        "path": "/sale/order/add",
        "parent": "3-1",
        "closable": true
    },
    {
        "id": "3-2",
        "name": "销售单",
        "path": "/sale/so",
        "parent": "3",
        "closable": true
    },
    {
        "id": "3-2-1",
        "name": "销售单详情",
        "path": "/sale/so/detail",
        "parent": "3-2",
        "closable": true
    },
    {
        "id": "3-2-2",
        "name": "新增销售单",
        "path": "/sale/so/add",
        "parent": "3-2",
        "closable": true
    },
    {
        "id": "3-3",
        "name": "销售退货",
        "path": "/sale/ro",
        "parent": "3",
        "closable": true
    },
    {
        "id": "3-3-1",
        "name": "销售退货单详情",
        "path": "/sale/ro/detail",
        "parent": "3-3",
        "closable": true
    },
    {
        "id": "3-3-2",
        "name": "新增销售退货单",
        "path": "/sale/ro/add",
        "parent": "3-3",
        "closable": true
    },
    {
        "id": "4-1",
        "name": "库存统计",
        "path": "/stock/statistic",
        "parent": "4",
        "closable": true
    },
    {
        "id": "4-2",
        "name": "库存盘点",
        "path": "/stock/check",
        "parent": "4",
        "closable": true
    },
    {
        "id": "4-2-1",
        "name": "库存盘点明细",
        "path": "/stock/check/detail",
        "parent": "4-2",
        "closable": true
    },
    {
        "id": "4-2-2",
        "name": "新增库存盘点",
        "path": "/stock/check/add",
        "parent": "4-2",
        "closable": true
    },
    {
        "id": "5-1",
        "name": "客户账单",
        "path": "/bill/customer",
        "parent": "5",
        "closable": true
    },
    {
        "id": "5-1-1",
        "name": "客户账单详情",
        "path": "/bill/customer/detail",
        "parent": "5-1",
        "closable": true
    },
    {
        "id": "5-2",
        "name": "供应商账单",
        "path": "/bill/supplier",
        "parent": "5",
        "closable": true
    },
    {
        "id": "5-2-1",
        "name": "供应商账单详情",
        "path": "/bill/supplier/detail",
        "parent": "5-2",
        "closable": true
    },
    {
        "id": "6-1",
        "name": "配件管理",
        "path": "/base/material",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-1-1",
        "name": "配件详情",
        "path": "/base/material/detail",
        "parent": "6-1",
        "closable": true
    },
    {
        "id": "6-1-2",
        "name": "新增配件",
        "path": "/base/material/add",
        "parent": "6-1",
        "closable": true
    },
    {
        "id": "6-2",
        "name": "仓库管理",
        "path": "/base/warehouse",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-2-1",
        "name": "仓库详情",
        "path": "/base/warehouse/detail",
        "parent": "6-2",
        "closable": true
    },
    {
        "id": "6-2-2",
        "name": "新增仓库",
        "path": "/base/warehouse/add",
        "parent": "6-2",
        "closable": true
    },
    {
        "id": "6-3",
        "name": "供应商管理",
        "path": "/base/supplier",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-3-1",
        "name": "供应商明细",
        "path": "/base/supplier/detail",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-3-2",
        "name": "新增供应商",
        "path": "/base/supplier/add",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-4",
        "name": "客户管理",
        "path": "/base/customer",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-4-1",
        "name": "客户明细",
        "path": "/base/customer/detail",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-4-2",
        "name": "新增客户",
        "path": "/base/customer/add",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-5",
        "name": "数据字典",
        "path": "/base/dict",
        "parent": "6",
        "closable": true
    },
    {
        "id": "6-6",
        "name": "缓存管理",
        "path": "/setting/cache",
        "parent": "6",
        "closable": true
    },
    {
        "id": "7-1",
        "name": "配件交易频次",
        "path": "/statistics/partDeal",
        "parent": "7",
        "closable": true
    },
    {
        "id": "7-2",
        "name": "进销存明细",
        "path": "/statistics/dinout",
        "parent": "7",
        "closable": true
    },
    {
        "id": "7-3",
        "name": "客户销售情况",
        "path": "/statistics/customerSale",
        "parent": "7",
        "closable": true
    },
    {
        "id": "7-4",
        "name": "供应商采购情况",
        "path": "/statistics/supplier",
        "parent": "7",
        "closable": true
    },
    {
        "id": "7-5",
        "name": "配件或客户销售情况",
        "path": "/statistics/partOrCustomer",
        "parent": "7",
        "closable": true
    }
]

function getPageById(id) {
    const retArr = pages.filter(el => el.id === id);
    if (retArr && retArr.length > 0) {
        return retArr[0];
    }
    return null
}

function getPathById(id) {
    const retArr = pages.filter(el => el.id === id);
    if (retArr && retArr.length > 0) {
        return retArr[0].path;
    }
    return null
}

function getPageByPath(path) {
    const retArr = pages.filter(el => el.path === path);
    if (retArr && retArr.length > 0) {
        return retArr[0];
    }
    return null
}

function getIdByPath(path) {
    const retArr = pages.filter(el => el.path === path);
    if (retArr && retArr.length > 0) {
        return retArr[0].id;
    }
    return null
}

function goPage(history, pageId) {
    let patPath = getPathById(pageId);
    history.push({ pathname: patPath, state: { id: pageId } });
}

export {
    getPageById,
    getPathById,
    getPageByPath,
    getIdByPath,
    goPage
}